<template>
  <div></div>
</template>
<script type="text/javascript">
const width = {
  appid: 160,
  info: 1000,
  no: 200,
  phone: 120,
  area: 300,
  addr: 300,
  openid: 250,
  iccid: 200,
  url: 500,
  cer_no: 300,
  serial: 150,
  certification: 100,
  status: 100,
  date: 150,
  groupId: 150,
  usage: 150,
  name: 130,
  order_no: 170,
  package: 290,
  number: 180,
  desc: 180,
  kind: 220,
  supplier: 250,
  amount: 200,
  email: 200
}
export default{
  width
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/card/components/global/index.vue